import { Network } from '@nsfw-app/crypto'
import { Button } from 'common/Button'
import { Icon } from 'common/Icon'
import { PopupDialog } from 'common/PopupDialog'
import { PopupDialogContent } from 'common/PopupDialog/PopupDialogContent'
import { tokenToIconMap } from 'config/chainsMap'
import { ChainListItem, NetworkList, NetworkListItem } from 'lib/web3/chains'
import { List } from 'primitives/List'
import { ListItem } from 'primitives/ListItem'
import { Text } from 'primitives/Text'

interface MobileDialogProps {
  isOpen: boolean
  onIgnore: () => void
  onClick: (chainId: Network) => void
  networks: NetworkListItem[]
}

export const NetworkSelectorDialog: React.FC<MobileDialogProps> = ({
  isOpen,
  onClick,
  onIgnore,
  networks,
}) => {
  return (
    <PopupDialog isOpen={isOpen} onIgnore={onIgnore} backdrop='blurred'>
      <PopupDialogContent>
        <List
          type='grouped'
          css={{ [`& ${ListItem}`]: { padding: 0, margin: 0 } }}
        >
          {networks.map(({ id, name }) => (
            <ListItem key={`chain-${id}`}>
              <Button web3Wallet onClick={() => onClick(id)}>
                <Text type='body2' css={{ whiteSpace: 'nowrap' }}>{name}</Text>
                <Icon
                  icon={tokenToIconMap[id]}
                  css={{ height: 20, width: 20 }}
                />
              </Button>
            </ListItem>
          ))}
        </List>
      </PopupDialogContent>
    </PopupDialog>
  )
}
